import React from "react";
import { connect } from "react-redux";
import { getUserParlourSales } from "../../../api/admin";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

/**
 * A host's parlour-sales report (5th tab of the user-detail screen): headline
 * totals (gross / platform fee / host payout / buyers) over a per-parlour table.
 * Reuses the same revenue split as the per-parlour report.
 */
function ParlourSales(props) {
  const [report, setReport] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let alive = true;
    if (!props.userId) return;
    setLoading(true);
    props.getUserParlourSales(props.userId).then((data) => {
      if (alive) {
        setReport(data);
        setLoading(false);
      }
    });
    return () => {
      alive = false;
    };
  }, [props.userId]);

  if (loading) return <p className="p-4 text-muted">Loading sales…</p>;
  if (!report) return <p className="p-4 text-muted">No sales data available.</p>;

  const cards = [
    { label: "Gross Revenue", value: money(report.grossRevenue), cls: "text-primary" },
    { label: "Platform Fee", value: money(report.platformFee), cls: "text-muted" },
    { label: "Host Payout", value: money(report.hostPayout), cls: "text-success" },
    { label: "Parlours", value: report.parlourCount },
    { label: "Sales", value: report.totalSales },
    { label: "Buyers", value: report.totalBuyers },
  ];

  return (
    <div className="p-3">
      <div className="row mb-2">
        {cards.map((c) => (
          <div className="col-6 col-md mb-2" key={c.label}>
            <div className="card h-100">
              <div className="card-body text-center py-3">
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  {c.label}
                </div>
                <div className={`font-weight-bold ${c.cls || ""}`} style={{ fontSize: "18px" }}>
                  {c.value}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="table-responsive">
        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Parlour</th>
              <th className="text-right">Price</th>
              <th className="text-right">Buyers</th>
              <th className="text-right">Sales</th>
              <th className="text-right">Gross</th>
              <th className="text-right">Platform Fee</th>
              <th className="text-right">Host Payout</th>
            </tr>
          </thead>
          <tbody>
            {report.parlours.map((p) => (
              <tr key={p.sellParlourId}>
                <td style={{ verticalAlign: "middle" }}>{p.title}</td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {money(p.price)}
                </td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {p.buyers}
                </td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {p.sales}
                </td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {money(p.grossRevenue)}
                </td>
                <td className="text-right text-muted" style={{ verticalAlign: "middle" }}>
                  {money(p.platformFee)}
                </td>
                <td className="text-right text-success" style={{ verticalAlign: "middle" }}>
                  {money(p.hostPayout)}
                </td>
              </tr>
            ))}
            {report.parlours.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center p-4">
                  This user hasn't hosted any parlours.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default connect(null, { getUserParlourSales })(ParlourSales);
